export const fileToBuffer = (file: File): Promise<ArrayBuffer> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      resolve(reader.result as ArrayBuffer);
    };
    reader.onerror = reject;
    reader.readAsArrayBuffer(file);
  });
};

export function downloadFile(file: File) {
  if ((window.navigator as any).msSaveOrOpenBlob) {
    // IE10+
    (window.navigator as any).msSaveOrOpenBlob(file, file.name);
  } else {
    // Others
    const a = document.createElement("a"),
      url = URL.createObjectURL(file);
    a.href = url;
    a.download = file.name;
    document.body.appendChild(a);
    a.click();
    setTimeout(function () {
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }, 0);
  }
}

export function replaceFileExtension(
  filename: string,
  newExtension: string,
): string {
  return filename.replace(/\.[^/.]+$/, newExtension);
}
